<template>
  <div class="orderList">
    <div class="orderFindBox">
      <div class="orderFindBox_title">购卡人联系电话：</div>
      <div class="orderFindBox_con">
        <el-input
          class="phoneNumberInp"
          size="medium"
          placeholder="请输入11位购卡人联系电话"
          maxlength="11"
          minlength="11"
          v-model="phoneNumber"
          clearable>
        </el-input>
        <el-button size="medium" class="searchBtn cursor" type="primary" @click="searchOrder()">搜索</el-button>
      </div>
    </div>

    <div class="orderListBox">
      <div class="orderListBoxNone" v-if="!orderListShow">
        <div class="orderListBoxNone_img">
          <img :src="orderListImg" alt="">
        </div>
        <div class="orderListBoxNone_desc">{{orderListDesc}}</div>
      </div>
      <div class="orderListBoxhas" v-else>
        <div class="orderListTitleList">
          <div class="orderListTitleItem">订单号</div>
          <div class="orderListTitleItem">等级</div>
          <div class="orderListTitleItem">号码</div>
          <div class="orderListTitleItem">地市</div>
          <div class="orderListTitleItem">首月服务费</div>
          <div class="orderListTitleItem">套餐预存费</div>
          <div class="orderListTitleItem">订单状态</div>
          <div class="orderListTitleItem">订单操作</div>
        </div>
        <div class="orderListConList">
          <div class="orderListConItem" v-for="(item,index) in orderList" :key="index">
            <div class="orderListCon_item">{{item.sdk_order_id}}</div>
            <div class="orderListCon_item">{{item.pretty == 1 ? '靓号' : '普号'}}</div>
            <div class="orderListCon_item">{{item.phone_number}}</div>
            <div class="orderListCon_item">{{item.home}}</div>
            <div class="orderListCon_item">¥{{(item.card_money/100).toFixed(2)}}</div>
            <div class="orderListCon_item">¥{{(item.prestore_money/100).toFixed(2)}}</div>
            <div class="orderListCon_item">{{orderStatuList[parseInt(item.order_status)-1]}}</div>
            <div class="orderListCon_item">
              <span class="lookOrderInfo cursor" @click="lookOrderInfo(item.sdk_order_id)">订单详情</span>
              <span class="lookExpress cursor" @click="lookExpress(item.sdk_order_id)" v-if="item.order_status==5||item.order_status==5||item.order_status==7">物流查询</span>
            </div>
          </div>
          <router-view></router-view>
        </div>
        
        <el-dialog
          title="物流详情"
          :visible.sync="dialogVisible"
          width="700px"
          top="100px"
          :before-close="handleClose">
          <express :sdk_order_id="sdk_order_id"></express>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">知道啦</el-button>
          </span>
        </el-dialog>

        
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import express from '../../components/express/express';
export default {
  name: "order",
  components: {
    express
  },
  data(){
    return {
      token : window.localStorage.getItem('token'),
      loading : '',
      phoneNumber : '',
      orderListShow : false,
      orderList : [],
      orderStatuList : ['进行中','已关闭','已支付','已制卡','已发货','已收货','已退货'],
      orderListImg : require('../../assets/listnone.png'),
      orderListDesc : '请在上方输入购卡人联系电话查询订单',
      dialogVisible : false,
      sdk_order_id : ''
    }
  },
  methods: {
    Loading : function(text){
      this.loading = Loading.service({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    alertMsg : function(msg){
      this.$message({
        message: msg,
        type: 'error',
        offset: '300'
      });
    },
    //订单查询
    searchOrder : function(){
      if(this.phoneNumber.length == '11'){
        this.Loading('订单查询中...');
        var params = {
          "token": this.token,
          "link_phone": this.phoneNumber
        }
        var that = this;
        this.$http.post('/getOrderList',params,{emulateJSON: true})
        .then(function(res){ 
          that.loading.close();
          var data = res.data;
          console.log(data)
          if(data.code == '200'){
            if(data.data.list.length){
              that.orderListShow = true;
              that.orderList = data.data.list;
            }else{
              that.orderListShow = false;
              that.orderList = [];
              that.orderListImg = require('../../assets/numberboxnone.png');
              that.orderListDesc = '暂无订单';
            }
          }else{
            that.alertMsg(data.msg);
          }
        }).catch(function(err){ 
          that.loading.close();
          that.alertMsg('订单查询失败，请重试');
        })
      }else{
        this.alertMsg('请输入11位购卡人联系电话');
      }
    },
    changeIndexHead : function(){
      this.$emit('changeIndexHeadFunc','2')
    },
    //查看订单详情
    lookOrderInfo : function(orderid){
      console.log('查看订单详情')
      this.$router.push({
        path:`/order/${orderid}`
      })
    },
    //物流查询
    lookExpress : function(sdk_order_id){
      this.sdk_order_id = sdk_order_id;
      this.dialogVisible = true;
    },
    handleClose(done) {
      done();
    }
  },
  mounted : function(){
    this.changeIndexHead();
    this.$emit('gotoOrder','2');
  },
  created:function(){
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .orderList {
    .cursor {
      cursor: pointer;
    }
    .orderFindBox {
      margin-top: 20px;
      background: #ffffff;
      width: 100%;
      padding: 20px 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      .orderFindBox_title {
        color: #303133; 
        font-size: 18px;
        margin-right: 20px;
      }
      .orderFindBox_con {
        display: flex;
        .phoneNumberInp {
          width: 350px;
          margin-right: 10px;
        }
      }
    }
    .orderListBox {
      margin-top: 20px;
      background: #ffffff;
      width: 100%;
      padding: 20px 50px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-radius: 8px;
      text-align: left;
      .orderListBoxNone {
        text-align: center;
        padding: 100px 0 150px;
        .orderListBoxNone_img {
          width: 210px;
          margin: 0 auto;
          padding-bottom: 10px;
          img {
            width:100%;
          }
        }
        .orderListBoxNone_desc {
          font-size: 20px;
          color: #BFBFBF;
          line-height:28px;
        }
      }
      .orderListBoxhas {
        .orderListTitleList {
          display: flex;
          align-items: center;
          background: #F7F7F7;
          text-align: center;
          padding: 16px 0;
          border-radius: 6px;
          color: #909399;
          font-weight:500;
          .orderListTitleItem:nth-of-type(1) {
            width: 15%;
          }
          .orderListTitleItem:nth-of-type(2) {
            width: 10%;
          }
          .orderListTitleItem:nth-of-type(3) {
            width: 12.5%;
          }
          .orderListTitleItem:nth-of-type(4) {
            width: 15%;
          }
          .orderListTitleItem:nth-of-type(5) {
            width: 12.5%;
          }
          .orderListTitleItem:nth-of-type(6) {
            width: 12.5%;
          }
          .orderListTitleItem:nth-of-type(7) {
            width: 10%;
          }
          .orderListTitleItem:nth-of-type(8) {
            width: 12.5%;
          }
        }
        .orderListConList {
          font-size: 16px;
          color: #595959;
          .orderListConItem {
            padding: 20px 0;
            display: flex;
            align-items: center;
            text-align: center;
          }
          .orderListCon_item:nth-of-type(1) {
            width: 15%;
          }
          .orderListCon_item:nth-of-type(2) {
            width: 10%;
          }
          .orderListCon_item:nth-of-type(3) {
            width: 12.5%;
            color: #595959;
            font-weight: 600;
          }
          .orderListCon_item:nth-of-type(4) {
            width: 15%;
          }
          .orderListCon_item:nth-of-type(5) {
            width: 12.5%;
          }
          .orderListCon_item:nth-of-type(6) {
            width: 12.5%;
          }
          .orderListCon_item:nth-of-type(7) {
            width: 10%;
          }
          .orderListCon_item:nth-of-type(8) {
            width: 12.5%;
            color: #1989FA;
            display: flex;
            flex-direction: column;
            align-items: center;
            line-height: 30px;
          }
        }
      }
    }
  }
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
